export default __webpack_public_path__ + "static/WebUI-MenuVideoBar_Audio-812acca3874b20ed1d45cfa9929b1a45.png";